import React, { useState, useEffect } from 'react';
import HttpHelper from '../service/httpService'
import { handleImageError } from 'base/Utility'
const KeyFeatures = (props) => {

    const [keyFeature, setKeyFeature] = useState({});

    const getKeyFeature = async () => {
        await HttpHelper.get("Website/GetKeyFeature").then((response) => {
            if (response.status === 200) {
                setKeyFeature(response.data);
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    useEffect(() => {
        getKeyFeature();
    }, [])

    return (<>
        <div class={`section section-padding-t90-b100 ${props.bgClass}`}>
            <div className="container shape-animate">
                {/* <!-- Section Title Start --> */}
                <div className="section-title text-center mb-lg-12 mb-sm-8 mt-5"
                // data-aos="fade-up"
                >
                    <h2 className="title">{keyFeature && keyFeature.length > 0 ? keyFeature.filter(x => x.type == 'Title')[0].title : ''}</h2>
                    <p className="sub-title title-w-90">
                        <span className="headingSubNormalText">{keyFeature && keyFeature.length > 0 ? keyFeature.filter(x => x.type == 'Title')[0].subTitle : ''}
                        </span></p>
                </div>
                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 icon-size-redefine keyfeature-tile">
                    {keyFeature.length > 0 && keyFeature.map((e, i) => {
                        if (e.type != 'Title') {
                            return (<>
                                <div className="col mb-xl-6" key={i}>
                                    <div className="contact-info" data-vivus-hover>
                                        <div class="col-md-12 col-12">
                                            {e.file != null ?
                                                <img src={`${e.file.fileUrl}`} onError={handleImageError} height="250" style={{ width: '100%' }} />
                                                :
                                                <img src={`${process.env.REACT_APP_PUBLIC_URL + '/assets/images/Missing.jpg'}`} height="250" style={{ width: '100%' }} />
                                            }
                                        </div>
                                        <div className="info mt-5 text-black text-bold card-heading" style={{ fontStyle: 'bold' }}>
                                            {e.title != null ? e.title : '-----'}
                                        </div>
                                        <div className="info mt-3 scrollbar-thin tile-area">
                                            <div dangerouslySetInnerHTML={{ __html: e.content }}></div>
                                        </div>
                                    </div>
                                </div>
                            </>)
                        }
                    })}
                </div>
                {/*<div className="shape shape-1 scene">*/}
                {/*    <span data-depth="4"><img src={process.env.REACT_APP_PUBLIC_URL + 'assets/images/shape-animation/video-shape-1.png'} alt="shape" /></span>*/}
                {/*</div>*/}
            </div>
        </div>
    </>)
}
export default KeyFeatures;